import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  HeaderContainer,
  Search,
  Title,
  Divider,
  Grid,
  Link,
  Icon,
  NoResults,
  LabelFirstName,
  LabelTranscriptText,
} from './styles';
import { NO_RESULTS_TEXT, PLACEHOLDER_LABEL_TEXT } from './constants';

const TranscriptChart = (props) => {
  const {
    data,
    projectId,
  } = props;
  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);

  const searchChange = ({ value }) => {
    setSearch(value === ' ' ? _.trim(value) : value);
  };

  useEffect(() => {
    if (search) {
      const filteredResults = data.filter((item) => item.firstName.toLowerCase().includes(search.toLowerCase())
        || item.transcriptText.toLowerCase().includes(search.toLowerCase()));
      setResults(filteredResults);
    } else {
      setResults(data);
    }
  }, [search, data]);

  return (
    <>
      <Divider />
      <HeaderContainer>
        <Title>Transcription</Title>

        <Search
          input={{
            icon: 'search',
            iconPosition: 'left',
          }}
          loading={false}
          onSearchChange={({ target }) => searchChange(target)}
          open={false}
          value={search}
          width="390px"
          placeholder={PLACEHOLDER_LABEL_TEXT}
        />
      </HeaderContainer>
      <Grid>
        {!_.isEmpty(results) && results.map((item) => (
          <Grid.Row key={`${item.id}-${item.firstName}`}>
            <Grid.Column width={2}>
              <LabelFirstName>
                {item.firstName}
              </LabelFirstName>
            </Grid.Column>
            <Grid.Column width={12}>
              <LabelTranscriptText>
                {item.transcriptText}
              </LabelTranscriptText>
            </Grid.Column>
            <Grid.Column witdh={2}>
              <Link href={`/projects/${projectId}/videos/${item.testerId}?time=${item.videoStartTime}`} target="_blank">
                Watch
                <Icon name="caret right" />
              </Link>
            </Grid.Column>
          </Grid.Row>
        ))}
        {_.isEmpty(results) && (
          <NoResults>
            {NO_RESULTS_TEXT}
          </NoResults>
        )}
      </Grid>
    </>
  );
};

TranscriptChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  projectId: PropTypes.string.isRequired,
};

export default TranscriptChart;
